import React from 'react';
import { Box } from '@withjoy/joykit';

interface WrapperProps {
  handleWrapClick: () => void;
  isMessageActive: boolean;
}

export const Wrapper: React.FC<WrapperProps> = ({ handleWrapClick, isMessageActive, children }) => (
  <Box
    paddingBottom={5}
    paddingX={3}
  >
    {isMessageActive ? (
      <Box
        paddingBottom={5}
        paddingX={3}
        background={'linear-gradient(360deg, #FFFFFF 0.02%, rgba(255, 255, 255, 0) 85.42%);'}
        onClick={handleWrapClick}
        role="button"
        cursor="pointer"
      >
        <Box
          maxHeight={['300px', null, '600px']}
          overflow="hidden"
          zIndex={-1}
          position="relative"
        >
          {children}
        </Box>
      </Box>
    ) : (
      <>{children}</>
    )}
  </Box>
);
